import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  Injectable,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { IAttributesSurvey } from '@npm-bbta/bbog-dig-dt-webcomponents-lib/dist/types/components/sherpa-ml/bdb-ml-bm-survey/IAttributesSurvey';
import { timer } from 'rxjs';
import { IUserStorage } from '../../models/userStorage';
import { StorageService } from '../../services/storage/storage.service';
import { ISurveyData } from '../../models/surveyType';
import { DashboardRedirectionService } from '../../services/redirect/redirectService';
import { Endpoints } from '../../models/endpoints';
import { RequestService } from '../../services/request/request.service';
import { SurveyService } from '../../../dashboard/services/survey/survey.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
})
export class SurveyComponent implements AfterViewInit {
  @ViewChild('superSurvey', { static: false }) surveyComponent: ElementRef;
  @Input() showSurvey: boolean;
  @Input() surveyName: string;
  @Input() question: string;
  @Injectable({
    providedIn: 'root',
  })
  public userStorage: IUserStorage;
  public listSurvey: IAttributesSurvey[] = [];
  public questions: IAttributesSurvey[] = [];
  public survey;
  public surveyId: number;

  constructor(
    private readonly storageService: StorageService,
    private readonly redirectionService: DashboardRedirectionService,
    private readonly requestService: RequestService,
    private readonly surveyService: SurveyService
  ) {}

  public additionalComments = [
    {
      title: 'Cuéntanos un poco más de tu respuesta',
      isRequired: false,
      questions: [
        {
          value: 'text',
          isTextArea: true,
          isChecked: true,
          hiddenClose: false
        },
      ],
    },
  ];

  closed = sessionStorage.getItem('closeSurvey') || 'open';
  private surveyCompleted = false;
  private countSubmmit = 0;




  async ngAfterViewInit(): Promise<void> {
    this.survey = await this.surveyService.isActiveSurvey(this.surveyName);
    this.countSubmmit = 0;

    if (this.survey !== null) {
      this.loadSurvey();
      this.surveyId = this.survey.id;
      this.openSurvey();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (!this.surveyCompleted) {
      $event.returnValue = 'You have unsaved changes! Are you sure you want to leave?';
    }
  }

  public markSurveyAsCompleted(): void {
    this.surveyCompleted = true;
  }

  loadSurvey(): void {
    this.questions.push(
      {
        title:
          this.survey !== undefined
            ? this.survey.question
            : '¿Consideras que el esfuerzo requerido para la creación de links cumplió con tus expectativas?',
        isRequired: true,
        questions: [
          {
            value: 'rate',
            rate: 5,
            isChecked: true,
            hiddenClose: false,
            textDisagreement: 'Muy insatisfecho',
            textAgreement: 'Muy satisfecho'
          },
        ],
      },
      {
        title: 'Last',
        isRequired: false,
        isLast: true,
      }
    );
    this.listSurvey = this.questions;
  }

  openSurvey(): void {
    this.surveyComponent.nativeElement.openSurvey();
  }

  public answerQuestion(e: any): void {
    const currentPage = e.detail.currentPage;
    const rating = e.detail.questions?.[0]?.questions?.[0]?.answerRate;
    if ((rating < 3 || this.surveyName === 'csat') && currentPage === 1 && this.listSurvey.length < 3 ) {
      this.addQuestion(currentPage);
    } else if (rating >= 3 && currentPage === 1 && this.listSurvey.length === 3) {
      this.resetQuestions();
    }

    if (currentPage === 1 && rating < 3) {
      this.resetComment();
    }

    if (this.listSurvey[currentPage]?.title === 'Last') {
      this.surveyCompleted = true;
      timer(2000).subscribe(() => {
        this.surveyComponent.nativeElement.closeSurvey();
      });
    }
  }

  async sendSurvey(event: any): Promise<void> {
    const user = this.storageService.getUser() as IUserStorage;
    const { channel, identificationNumber: advisorIdentificationNumber } = user;
    const response: ISurveyData = {
      advisorIdentificationNumber,
      channel,
      rating: event.detail.questions[0]?.questions[0]?.answerRate,
      product: this.redirectionService.getData().product,
      idSurvey: this.surveyId,
    };
    const additionalComment = event.detail.questions?.[1]?.questions?.[0]?.answerText;
    if (additionalComment && additionalComment.length > 1) {
      response.comments = additionalComment;
    }

    this.redirectionService.setRedirected(false);

    if (this.countSubmmit === 0) {
      this.countSubmmit = 1;
      await this.requestService.post(Endpoints.NEWCESRECORD, {
        headers: { 'X-RqUID': user.rqUuid },
        body: JSON.stringify(response),
      });
    }
    this.closed = 'closed';
    window.sessionStorage.setItem('closeSurvey', String(this.closed));
  }

  public addQuestion(currentPage: number): void {
    this.listSurvey.splice(currentPage, 0, this.additionalComments[0]);
  }

  public resetQuestions(): void {
    this.listSurvey.splice(1, 1);
  }

  private resetComment(): void {
    if (this.listSurvey[1]?.questions?.[0]) {
      this.listSurvey[1].questions[0].answerText = '';
    }
  }
}
